<template>
  <delegation-order-form ref="delegationOrderForm" />
</template>

<script>
import DelegationOrderForm from "../../components/DelegationOrder/DelegationOrderForm";
export default {
  name: "DelegationOrderEditView",
  components: { DelegationOrderForm },
  beforeRouteLeave(from, to, next) {
    this.$refs.delegationOrderForm.beforeRouteLeave(from, to, next);
  }
};
</script>

<style scoped></style>
